module.exports = __webpack_public_path__ + "img/empty-report.d8488fb1.png";